<template>
  <div>
    <canvas ref="canvas" />
  </div>
</template>

<script>
import Chart from 'chart.js/auto';

export default {
  name: 'HorizontalBarChart',
  props: {
    labels: {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    barColor: {
      type: String,
      default: '#F65E5E'
    },
    title: {
      type: String,
      default: ''
    },
    maxBars: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      chart: null
    };
  },
  computed: {
    chartLabels() {
      return this.labels.slice(0, this.maxBars);
    },
    chartData() {
      return this.data.slice(0, this.maxBars);
    },
    valueLabelPlugin() {
      return {
        id: 'valueLabel',
        afterDatasetsDraw: chart => {
          const ctx = chart.ctx;
          ctx.save();
          const dataset = chart.getDatasetMeta(0);
          dataset.data.forEach((bar, i) => {
            const value = this.chartData[i];
            const barWidth = bar.x - bar.base;
            ctx.font = 'bold 16px Poppins';
            const text = value.toString();
            const textWidth = ctx.measureText(text).width;
            let x, color, align;
            if (barWidth > textWidth + 16) {
              x = bar.x - 8;
              color = '#fff';
              align = 'right';
            } else {
              x = bar.x + 8;
              color = '#222';
              align = 'left';
            }
            ctx.fillStyle = color;
            ctx.textAlign = align;
            ctx.textBaseline = 'middle';
            ctx.fillText(text, x, bar.y);
          });
          ctx.restore();
        }
      };
    }
  },
  watch: {
    labels: 'renderChart',
    data: 'renderChart',
    barColor: 'renderChart',
    title: 'renderChart',
    maxBars: 'renderChart'
  },
  mounted() {
    this.renderChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    renderChart() {
      if (this.chart) {
        this.chart.destroy();
      }
      const ctx = this.$refs.canvas.getContext('2d');
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: this.chartLabels,
          datasets: [
            {
              data: this.chartData,
              backgroundColor: this.barColor,
              borderRadius: 8,
              barThickness: 30
            }
          ]
        },
        options: {
          indexAxis: 'y',
          responsive: true,
          plugins: {
            legend: { display: false },
            title: {
              display: !!this.title,
              text: this.title,
              align: 'start',
              font: { size: 18, weight: 'bold', family: 'Poppins' },
              padding: { bottom: 20 }
            },
            tooltip: { enabled: false }
          },
          scales: {
            x: {
              display: false,
              beginAtZero: true,
              grid: { display: false },
              ticks: { font: { family: 'Poppins', size: 14 } }
            },
            y: {
              grid: { display: false },
              ticks: { font: { family: 'Poppins', size: 14 } }
            }
          }
        },
        plugins: [this.valueLabelPlugin]
      });
    }
  }
};
</script> 